module.exports = __webpack_public_path__ + "static/template_options_week_column_with_color_sidebars-a217cdf1143e6e9a0a395ecea2838012.png";